import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
import { Geolocation } from '@ionic-native/geolocation';
import { NativeGeocoder, NativeGeocoderReverseResult } from '@ionic-native/native-geocoder';
import $ from 'jquery';
import { Storage } from '@ionic/storage';
import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { MymodelProvider } from '../../providers/mymodel/mymodel';
import { ResumeinstalasiPage } from '../resumeinstalasi/resumeinstalasi';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
/**
 * Generated class for the FinstalasihdPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-finstalasihd',
  templateUrl: 'finstalasihd.html',
})
export class FinstalasihdPage {

  konmes = '';
  keterangan = '';
  id_scan_header: any;
  loading: Loading;
  myWO: any;
  lokasi: any;
  lat: any;
  lang: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    public mymodel: MymodelProvider,
    private locationAccuracy: LocationAccuracy,
    public storage: Storage,
    public http: Http,
    public geo: Geolocation,
    public nativeGeocoder: NativeGeocoder,
    private scanner: BarcodeScanner,
  ) {
    this.getData();
  }

  public createLoader(message: any) {
    this.loading = this.loadingCtrl.create({
      content: message
    });
  }
  public dissmissloading() {
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  ionViewDidLoad() {
    var date = new Date();
    var bln = date.getMonth()+1;
    var tgl = date.getDate();
    var today = date.getFullYear()+'-'+(bln<10 ? '0' : '')+bln+'-'+(tgl<10 ? '0' : '')+tgl;
    $('#today').text(': '+today);
    this.getData();
    this.myWO = JSON.parse(localStorage.getItem('datawoinstalasi'));
    console.log(this.myWO);
    
  }

  getData(){
    var mymodel = this.mymodel;
    var storage = this.storage;
    var wo = [];
    var kodeTeknisi = JSON.parse(localStorage.getItem('dataTeknisi'))[0].Kode_Karyawan;
    // "https://35.240.151.223:43209/get-data-wo-instalasi/:kodeTeknisi"
    $.ajax({
      url: "http://35.240.151.223:43209/apiwebteknisi/get-data-wo-instalasi/"+kodeTeknisi,
      type: "get",
      dataType: "json",
      success: function (result) {
        var wo2 = [];
        var status = result.success;
        var data = result.data;
        localStorage.removeItem('datawoinstalasi');
        localStorage.setItem('datawoinstalasi', JSON.stringify(data));
        console.log(kodeTeknisi);
      }
    });
    // this.myWO = [JSON.parse(localStorage.getItem('dataWO'))];
  }

  refreshWO(event){
    this.myWO = null;
    this.getData();
    // this.myWO = JSON.parse(localStorage.getItem('dataWO'));

    setTimeout(() => {
      this.myWO = JSON.parse(localStorage.getItem('datawoinstalasi'));
      console.log('berhasil merefresh data');
      event.complete();
    }, 1000);
  }

  cekStatus1(value) {
    let color = new String;
    if (value == '0') {//0 = UNREAD    ABU-ABU
      color = "onnotyet";
    } else if (value == '1') {//2 = PROGRESS	BIRU
      color = "onproccess";
    } else if (value == '2') {//   3 = CLOSE		  MERAH
      color = "onclose";
    }
    return color;
  }

  cekStatus2(value) {
    let txt = new String;
    if (value == '0') { //0 = blm proses    ABU-ABU
      txt = "NOT YET";
    } else if (value == '1') { //2 = PROGRESS	BIRU
      txt = "ON PROCESS";
    } else if (value == '2') { //   3 = CLOSE		MERAH
      txt = "CLOSED";
    }
    return txt;
  }

  // scanbarcode(datawo) {
  //   this.locationAccuracy.canRequest().then((canRequest: boolean) => {
  //     this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
  //       () => {
  //         this.geo.getCurrentPosition().then((pos) => {
  //           this.lat = pos.coords.latitude;
  //           this.lang = pos.coords.longitude;
  //           this.nativeGeocoder.reverseGeocode(this.lat, this.lang)
  //             .then((result: NativeGeocoderReverseResult[]) => {
  //               this.lokasi = JSON.stringify(result);
  //               this.scanner.scan().then(barcodeData => {
  //                 if (barcodeData.text != "") {
  //                   $.ajax({
  //                     url: "http://35.240.151.223:43209/apiwebteknisi/send-barcode-instalasi",
  //                     type: "post",
  //                     data: datawo,
  //                     dataType: "json",
  //                     success: function (feedback) {
  //                       var pesan = feedback.pesan;
  //                       var hasil = feedback.data;
  //                     }
  //                   });
  //                 }
  //               }).catch(err => {
  //                 alert(err);
  //               });
  //             }).catch((error) => {
  //               alert("#4Error " + error);
  //             });
  //         }).catch((error) => {
  //           alert("#3Error " + error);
  //         });
  //       }).catch((error) => {
  //         alert("#2Error " + error);
  //       });
  //   }).catch((error) => {
  //     alert("#1Error " + error);
  //   });
  // }

  resume(item){
    this.navCtrl.push(ResumeinstalasiPage, {"nowo": item.no_wo });
  }

}



// WEBPACK FOOTER //
// ./src/pages/finstalasihd/finstalasihd.ts